import React from 'react';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { useTranslation } from 'react-i18next';
import './Breadcrumb.scss';

export const Breadcrumb = ({ sitecoreContext, ...props }) => {
    const { className } = props;
    const { breadcrumbs, route } = sitecoreContext;
    const { breadcrumbShow } = route.fields;
    const { t } = useTranslation();

    return breadcrumbShow && breadcrumbs.items.length > 1 ? (
        <nav aria-label="breadcrumbs" className={className}>
            <h2 className="visually-hidden">
                {t('breadcrumb.heading.text', {
                    defaultValue: 'You are here:',
                })}{' '}
            </h2>
            <ol className="breadcrumbs">
                {breadcrumbs &&
                    breadcrumbs.items.map((crumb, index) => {
                        const currentPage =
                            breadcrumbs.items.length === index + 1;
                        const breadcrumbKeys = `breadcrumb${index}`;
                        return (
                            <li key={breadcrumbKeys}>
                                {!currentPage && (
                                    <a href={crumb.path}>{crumb.name}</a>
                                )}
                                {currentPage && (
                                    <span aria-current="page">
                                        {crumb.name}
                                    </span>
                                )}
                            </li>
                        );
                    })}
            </ol>
        </nav>
    ) : null;
};

export default withSitecoreContext()(Breadcrumb);
